import React, { useState,useEffect } from "react";
import {Redirect} from 'react-router-dom'//yarn add @types/react-router-dom
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Grid from '@mui/material/Grid';
import Hidden from '@mui/material/Hidden';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import useStyles from './Styles';
import {Owner,Item} from './Inc';
import {Tools} from './Tools';
import StoreImg from './StoreImg';
import Ajax from './Ajax';
import BottomButtons from './BottomButtons';
import RowData from './RowData';
import Toast from './Toast';
import Yesno from './Yesno';
import Loading from './Loading';
import Title from './Title';

interface Props {
    owner:Owner,
}

//let itemIds:number[] = [];

const SortItems = (props:Props)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();

    const defItems:Item[] = [];
    const [states,setStates] = useState({
        items: defItems,
		itemIds: [] as number[],
		updated: false,
        isLoading: false,
        toast: "",
        yesno: "",
    });

    const reorder = (list:Item[], startIndex:number, endIndex:number) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    };

    const grid = 8;

    const getItemStyle = (isDragging:boolean, draggableStyle:any) => ({
        // some basic styles to make the items look a bit nicer
        userSelect: "none",
        padding: grid * 2,
        margin: `0 0 ${grid}px 0`,

        // change background colour if dragging
        background: isDragging ? "lightgreen" : "white",
        border: `1px solid #CCCCCC`,

        // styles we need to apply on draggables
        ...draggableStyle
    });

    const getListStyle = (isDraggingOver:boolean) => ({
        background: isDraggingOver ? "#EEEEFF" : "#EEEEEE",
        padding: 0,
        width: "100%"
    });

    const onDragEnd = (result:any)=>{
        // dropped outside the list
        if (!result.destination) {
            return;
        }

        const items = reorder(
            states.items,
            result.source.index,
            result.destination.index
        );

        let itemIds = new Array<number>(items.length).fill(0);
        
        for( let i=0 ; i<items.length ; i++ ){
            itemIds[i] = items[i].item_id;
        }
        setStates({...states,updated:true,items:items,itemIds:itemIds});
    }

    const search = ()=>{
        setStates({...states,"isLoading":true});
        //console.log("sort/list");
        Ajax.send("sort/list",{},(res:any)=>{
            //console.log("sort/list/res",res);
            if( res.ok ){
                setStates({items:res.items,itemIds:[],isLoading:false,toast:"",yesno:"",updated:false});
            } else {
                setStates({...states,"isLoading":false});
            }
        });
    }

    const resetYes = ()=>{
        Ajax.send("sort/reset",{},(res:any)=>{
            if( res.ok ){
                setStates({...states,updated:false,"toast":"表示順をリセットしました"});
                search();
            }
        });
    }
    const resetNo = ()=>{
        setStates({...states,"yesno":""});
    }
    const closeToast = ()=>{
        setStates({...states,"toast":""});
    }
	const confirm = ()=>{
		//console.log(itemIds);
		if( states.itemIds.length===0 ){
			setStates({...states,"toast":"表示順が変わっていません"});
			return;
		}
		Ajax.send("sort/update",{item_ids:states.itemIds},(res:any)=>{
			if( res.ok ){
				setStates({...states,updated:false,"toast":"表示順を更新しました"});
			}
		});
	}
	const reset = ()=>{
		setStates({...states,"yesno":"表示順をリセットします。\nよろしいですか？"});
	}
	
    useEffect( ()=>{
		if( props.owner.owner_id>0 ){
        	search();
		}
    },[]);

	if( props.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

    if( states.isLoading ){
        return (
            <Loading isLoading={true}/>
        )
    }
    return (
		<div id="sort_items" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="商品表示順（本・雑貨）"/>
                        <div style={{marginBottom:"2em"}}>
                        あなたの作品リストで表示される商品の順番を編集できます。上から順に表示されますので、ドラッグ＆ドロップで入れ替えて下さい。<br/>
                        </div>
						<Hidden mdUp implementation="js">
							<BottomButtons button1='この内容で更新する' onClick1={confirm} disabled1={!states.updated} button2='リセット' onClick2={reset}/>
						</Hidden>


        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable">
                {(provided, snapshot) => (
                    <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={getListStyle(snapshot.isDraggingOver)}
                    >
                        {states.items.map((item, index) => {
                            return (
                                <Draggable key={item.item_id} draggableId={String(item.item_id)} index={index}>
                                    {(provided, snapshot) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={getItemStyle(
                                            snapshot.isDragging,
                                            provided.draggableProps.style
                                            )}
                                        >
                                            <div style={{position:"relative"}}>
                                                <div style={{position:"absolute",top:"0",left:"-0.5em",width:"80px",height:"110px",textAlign:"center",lineHeight:"1.4em"}}>
                                                    <StoreImg owner_id={props.owner.owner_id} img_id={item.img_id} className="imgSortItem"/>
                                                    <span className={classes.itemId}>ID:{item.item_id}</span>
                                                </div>
                                                <div style={{marginLeft:"85px",minHeight:"110px",lineHeight:"1.2em"}}>
                                                    {item.item_name}<br/>
                                                </div>
                                                <div style={{position:"absolute",bottom:"0",right:"-0.5em"}}>
                                                    {Tools.colorLabel("item_status",item.status,item.status_label)}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            )}
                        )}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>



                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <Paper className={classes.paper}>
                        <Title text="管理情報" size={2}/>
                        <RowData name="商品数" value={String(states.items.length)}/>
						<Divider style={{margin:'1em 0'}}/>
                        <Hidden mdDown implementation="js">
							<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
								<Button variant="contained" color="primary" style={{width:"100%",marginBottom:'0.25em'}} onClick={confirm} disabled={!states.updated}>この内容で更新する</Button>
								<Button variant="outlined" color="primary" style={{width:"100%"}} onClick={reset}>リセット</Button>
							</FormControl>
							<ul style={{paddingLeft:"1.5em",paddingRight:"0.5em"}}>
								<li>最後に「決定」を押すまでは編集内容は保存されません。</li>
								<li>背景が赤の商品は、お客様（購入者）からは現在見えていない商品です。</li>
								<li>状態（在庫なし等）の表記はお客様から見た場合の表記です。例えば納品済でも発売日が決まっていなければ在庫なしと表記されます。</li>
								<li>表示順を決めた後に追加された商品がある場合は先頭に表示されます。</li>
								<li>リセットすると最近発売された順に戻ります。</li>
							</ul>
                        </Hidden>
                    </Paper>

                </Grid>
            </Grid>
            <Toast mes={states.toast} close={closeToast}/>
            <Yesno yes={resetYes} no={resetNo} mes={states.yesno} isOpen={states.yesno!==""}/>
		</div>        
    );
}

export default SortItems;
